import React, { PropsWithChildren } from 'react';
import { Box } from '@zoopla-eng/zds/box';
import { layoutMediaWrapperStyle } from './layout-media.styles.css';

type LayoutMediaProps = {
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

export const LayoutMedia: React.FC<PropsWithChildren<LayoutMediaProps>> = ({
    children,
    onClick
}) => (
    <div className={layoutMediaWrapperStyle} onClick={onClick}>
        <Box width="100%" height="100%">
            {children}
        </Box>
    </div>
);
